import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, Text, useStyles, View} from "shared/base"
import React, {useMemo} from "react"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import {StyleSheet} from "react-native"

const styles = StyleSheet.create({
  description: {
    marginTop: -7,
    marginLeft: -2,
    fontFamily: "DreamChaser",
    fontSize: 20,
    fontStyle: "italic"
  },
  descriptionInactive: {
    color: "#87a2d5"
  },
  icon: {
    color: "#fff"
  },
  iconContainer: {
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 1,
    paddingLeft: 4,
    width: 40,
    height: 40,
    borderRadius: "50%"
  },
  iconContainerActive: {
    backgroundColor: "#5253ff"
  },
  iconContainerInactive: {
    borderColor: "#87a2d5",
    borderStyle: "dashed",
    borderWidth: 2
  },
  root: {
    flexDirection: "row",
    alignItems: "center"
  },
  text: {
    fontSize: 10
  },
  textInactive: {
    color: "#87a2d5"
  },
  textContainer: {
    marginLeft: 12
  },
  textWithDescription: {
    marginTop: 6
  }
})

/**
 * @typedef {object} ActiveStepProps
 * @property {boolean} active
 * @property {unknown} description
 * @property {unknown} label
 */

/** @typedef {object} ActiveStepState */

/**
 * @extends {ShapeComponent<ActiveStepProps, ActiveStepState>}
 */
class ActiveStep extends ShapeComponent {
  static defaultProps = {
    active: false,
    description: null
  }

  static propTypes = propTypesExact({
    active: PropTypes.bool.isRequired,
    description: PropTypes.string,
    label: PropTypes.string.isRequired
  })

  render() {
    const {active, description, label} = this.p
    const dataSet = useMemo(() => ({component: "routes/user/create-user/active-step"}), [])
    const rootStyle = useStyles(styles, "root")
    const iconContainerStyle = useStyles(styles, ["iconContainer", {
      iconContainerActive: active,
      iconContainerInactive: !active
    }])
    const descriptionStyle = useStyles(styles, ["description", {
      descriptionInactive: !active
    }])
    const textStyle = useStyles(styles, ["text", {
      textInactive: !active,
      textWithDescription: Boolean(description)
    }])

    return (
      <View dataSet={dataSet} style={rootStyle}>
        <View style={iconContainerStyle}>
          {active &&
            <Icon name="chevron-right" size={22} style={styles.icon} />
          }
        </View>
        <View style={styles.textContainer}>
          <Text style={textStyle}>
            {label}
          </Text>
          {description &&
            <Text style={descriptionStyle}>
              {description}
            </Text>
          }
        </View>
      </View>
    )
  }
}

export default memo(shapeComponent(ActiveStep))
